import { render, staticRenderFns } from "./authorizationDetail.vue?vue&type=template&id=0ccb0faa&scoped=true&"
import script from "./authorizationDetail.vue?vue&type=script&lang=js&"
export * from "./authorizationDetail.vue?vue&type=script&lang=js&"
import style0 from "./authorizationDetail.vue?vue&type=style&index=0&id=0ccb0faa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccb0faa",
  null
  
)

export default component.exports